/**
 * Change format currency
 *
 * @public
 * @param {number} currency 56000
 * @returns {string} new format currency 56 000
 */
export const formatCurrency = (currency: number): string =>
  currency.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
